<template>
  <div class="container-fluid">
    <div id="topo" class="card-header">
      <div class="row">
        <div class="col col-xs-2">
          <h4 class="panel-title">
            <span class="title">Consulta de Transferências.</span>
            <br />
            <span class="navigation">Obras > Consulta</span>
          </h4>
        </div>
      </div>
      <!--row-->
    </div>
    <!--card-header-->
    <TabView>
      <TabPanel header="Consultar Transferência">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="filtro">Filtro:</label>
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" />
              </span>
            </div>
            <div class="mb-2">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button
                  label="Pesquisar"
                  title="Pesquisar"
                  icon="pi pi-search"
                  :disabled="search"
                  @click="pesquisar()"
                />
              </span>
            </div>
            <div class="mb-2" style="padding-left:2px">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button
                  label="Limpar"
                  title="Limpar"
                  icon="pi pi-trash"
                  :disabled="search"
                  @click="clear()"
                />
              </span>
            </div>
          </div>
          <!--row-->

          <div class="row">
            <DataTable
              :value="transferenciasList"
              :paginator="true"
              :rows="10"
              class="p-datatable-responsive"
              :autoLayout="true"
            >
            <Column headerStyle="width: 4.2em">
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button class="btn btn-primary" type="button" icon="pi pi-angle-down" id="dropdownMenuButton"
                      title="Opções" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item" type="button" :disabled="loading"
                        @click="detail(slotProps.data.id)"><span
                          class="pi pi-search mr-2"></span>Visualizar</button>
                      <button
                        class="dropdown-item"
                        type="button"
                        @click="visualizarAnexo(slotProps.data.id)"
                      >
                        <span class="pi pi-envelope mr-2"></span>Anexo
                      </button>
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                field="idObras.numeroCei"
                header="Número CEI Obra"
              ></Column>
              <Column
                field="tipoTransacaoFormatada"
                header="Tipo Transação"
              ></Column>
              <Column field="notaEspecieFormatada" header="Espécie"></Column>
              <Column field="notaNumero" header="Número Nota"></Column>
              <Column
                field="saldoDedutivelFormatado"
                header="Valor Dedutível Material"
              ></Column>
              <Column
                field="estoqueMateriaisFormatado"
                header="Estoque de Materiais"
              ></Column>
              <Column
                field="obraOrigemConsulta.numeroCei"
                header="Origem"
              ></Column>
              <Column
                field="obraDestinoConsulta.numeroCei"
                header="Destino"
              ></Column>
            </DataTable>
          </div>
          <!--row-->
          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/transferenciasCadastro">
                <Button
                  type="button"
                  icon="pi pi-plus"
                  label="Novo"
                  title="Novo"
                />
              </router-link>
            </span>
          </div>
        </div>
        <!--card-body-->
      </TabPanel>
      <TabPanel header="Importar Transferência">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <span class="p-fluid">
                <a href="https://s3.amazonaws.com/el.com.br/nfse/layout_transf_materias_obra.pdf" style="padding-left: 2px;"
                  target="_blank">Clique aqui e faça o download do Layout...</a>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <hr />
              <input type="file" @change="onFileChanged" accept=".txt" />
              <hr />
              <Button
                @click="onUpload()"
                label="Upload"
                type="button"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="!this.fileSelect"
              />
              <Button
                @click="removerFile()"
                label="Remover"
                type="button"
                class="p-button-primary mr-2 p-button-danger"
                icon="pi pi-check"
                :disabled="!this.exibirFile"
              />
            </div>
          </div>
        </div>
      </TabPanel>

      <TabPanel header="Importar NF-e">
        <div class="card-body">
          <div class="row">
            <div class="mb-3 "><strong>O arquivo a ser importado refere-se ao modelo nacional da Nota Fiscal Eletrônica (NF-e) em formato XML.</strong></div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="obra">Obra Destino: *</label>
              <span class="p-fluid">
                <AutoComplete id="obra" v-model="selectedObrasDirecionamento" :dropdown="true"
                  :suggestions="filteredObrasDirecionamento"
                  @complete="searchObrasDirecionamento($event)" field="numeroCeiAndNomeObra"
                  placeholder="Pesquisar">
                  <template #item="slotProps">
                    <div class="p-fluid" style="max-width: 50vw">
                      {{ slotProps.item.numeroCei }} - {{ slotProps.item.nome }}
                    </div>
                  </template>
                </AutoComplete>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-2">
              <hr />
              <input type="file" @change="onFileChanged" accept=".xml" />
              <hr />
              <Button
                @click="onUploadNfeXml()"
                label="Upload"
                type="button"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="!this.fileSelect"
              />
              <Button
                @click="removerFile()"
                label="Remover"
                type="button"
                class="p-button-primary mr-2 p-button-danger"
                icon="pi pi-check"
                :disabled="!this.exibirFile"
              />
            </div>
          </div>
        </div>
      </TabPanel>

    </TabView>
    <Dialog
      header="Aviso"
      :visible.sync="display"
      :style="{ width: '30vw' }"
      :modal="true"
    >
      Confirmar a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" title="Sim" />
        <Button
          label="Não"
          icon="pi pi-times"
          @click="close"
          title="Não"
          class="p-button-secondary"
        />
      </template>
    </Dialog>
    <Dialog header="Anexo" :visible.sync="displayAnexos" :style="{ width: '35vw' }" :modal="true">
			<DataTable :value="anexos" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
				<template #empty>Nenhum anexo encontrado.</template>
				<Column headerStyle="width: 2.5em" header bodyStyle="text-align: center">
					<template #body="slotProps">
						<Button type="button" title="Download" class="p-button-primary mr-2" icon="pi pi-download"
							style="margin-right: 0.5em" @click="
								downloadArquivo(
									slotProps.data.id,
									slotProps.data.tipoArquivo,
									slotProps.data.nomeArquivo,
								)
								" :disabled="loading"></Button>
					</template>
				</Column>
				<Column field="nomeArquivo" header="Arquivo" bodyStyle="text-align:right"></Column>
			</DataTable>
			<template #footer>
				<Button label="Fechar" icon="pi pi-times" @click="displayAnexos = false" class="p-button-danger" />
			</template>
		</Dialog>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import TransferenciasService from "../services/obras/transferencias.service";

export default {
  name: "TransferenciasConsulta",
  data() {
    return {
      loading:false,
      display: false,
      search: false,
      filtro: "",
      transferenciasList: [],
      id: null,
      selectedFile: "",
      fileSelect: false,
      exibirFile: false,
      anexos:[],
			displayAnexos:false,
      selectedObrasDirecionamento: null,
      filteredObrasDirecionamento: null
    };
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },

  methods: {
    clear() {
      this.filtro = "";
      this.pesquisar();
    },
    pesquisar() {
      this.search = true;
      TransferenciasService.findTransferenciasByFiltro(
        this.currentUser.contribuinte.idContribuinte,
        this.filtro
      ).then(
        (transferencias) => {
          this.transferenciasList = transferencias.data;
        },
        (error) => {
          let errorMessage = "Houve um problema ao listar Transferências!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
          });
        }
      );
      this.search = false;
    },
    detail(id) {
      this.$router.push({
        name: "TransferenciasCadastro",
        params: { idTransferencias: id },
      });
    },
    confirmRemove(id) {
      this.id = id;
      this.display = true;
    },
    close() {
      this.id = null;
      this.display = false;
    },
    remove() {
      TransferenciasService.removeTransferencias(this.id).then(
        (data) => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Transferência removida com sucesso",
          });
          setTimeout(async () => {
            await this.pesquisar();
            this.display = false;
          }, 250);
        },
        (error) => {
          let errorMessage = "Houve um problema ao remover a Transferência!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
          });
        }
      );
    },
		visualizarAnexo(id) {
			this.processando(true);
			this.anexos = [];
			TransferenciasService.carregarAnexosTransferencia(
				id
			).then((response) => {
				this.anexos = response.data;
				this.displayAnexos = true;
			}).then(() => {
				this.processando(false);
			});
		},
		downloadArquivo(id, type, nome) {
			this.processando(true);
			TransferenciasService.downloadAnexo(
				id, type, nome
			).then(
				(data) => {
					console.log(data);
				},
				(error) => {
					this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
					console.log(error);
				}
			)
				.then(() => {
					this.processando(false);
				});
		},
    onFileChanged(event) {
      const file = event.target.files[0];
      this.selectedFile = file;
      this.fileSelect = true;
    },
    processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		},
    onUpload() {
      TransferenciasService.upload(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.selectedFile
      ).then(
        (response) => {
          console.log(response);
          // this.image = "";
          // this.getDados();
          this.$root.$emit("alert:success", "Transferência realizada com sucesso!");
        },
        (error) => {
          let errorMessage = "Houve um problema ao realizar o Upload!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$root.$emit("alert:error", errorMessage);
        }
      );
    },
    onUploadNfeXml() {
      if (this.selectedObrasDirecionamento && this.selectedObrasDirecionamento.numeroCei ) {
        TransferenciasService.uploadNfeXml(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.selectedObrasDirecionamento.numeroCei,
        this.selectedFile
        ).then(
          (response) => {
            console.log(response);
            // this.image = "";
            // this.getDados();
            this.$root.$emit("alert:success", "Importação de NF-e realizada com sucesso!");
            this.pesquisar();
          },
          (error) => {
            let errorMessage = "Houve um problema ao realizar o Upload!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$root.$emit("alert:error", errorMessage);
          }
        );
      } else {
        this.$root.$emit("alert:warn", "A Obra Destino deve ser selecionada!");
      }
    },
    searchObrasDirecionamento(event) {
			setTimeout(async () => {
				this.filteredObrasDirecionamento = await TransferenciasService.findObrasByFiltro(
					this.currentUser.contribuinte.idContribuinte,
					event.query
				);
			}, 550);
		},
  },
};
</script>
